export default "/assets/Icon/visa.svg"